export default "__VITE_ASSET__DQAJOKha__"